import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import classNames from '../../utils/classNames';

import styles from './snackbar.scss';

export default function Snackbar(props) {
    const { text, delay = 3000, onClosed } = props;
    const [opened, setOpened] = React.useState(false);
    const [closing, setClosing] = React.useState(false);

    let closeTimer = null;

    useEffect(() => {
        startCloseTimer();
    }, [text]);

    function startCloseTimer() {
        if (closeTimer) {
            clearTimeout(closeTimer);
        }

        const timeout = !isNaN(delay) ? delay : 3000;
        closeTimer = setTimeout(handleClose, timeout);
    }

    function handleClose() {
        setOpened(true);
        setClosing(true);
    }

    function handleAnimationEnd() {
        if (!closing) {
            setOpened(true);
        } else {
            if (typeof onClosed === 'function') {
                onClosed();
            }
        }
    }

    return ReactDOM.createPortal(
        <div className={classNames(styles.wrapper, {
            [styles.opened]: opened,
            [styles.closing]: closing,
        })} onAnimationEnd={handleAnimationEnd}>
            <div className={styles.content}>
                <p>{text}</p>
            </div>
        </div>,
        document.getElementById('popouts-portal')
    );
};

Snackbar.propTypes = {
    text: PropTypes.string.isRequired,
    /**
     * Delay in miliseconds before popup will be closed.
     */
    delay: PropTypes.number,
    /**
     * Triggers when snackbar closed.
     */
    onClosed: PropTypes.func,
};
